// Mock data for Aura Aesthetics

export const businessInfo = {
  name: "Aura Aesthetics Academy",
  tagline: "Revitalize Your Beauty with Aesthetic IV Infusions",
  description: "At Aura Aesthetics, we merge artistry with science to enhance natural beauty and inspire confidence. We are passionate about self-care, offering personalized, high-quality treatments that celebrate individuality and self-expression.",
  commitment: "With a commitment to innovation and integrity, we stay at the cutting edge of the industry, tailoring advanced techniques to each client's unique needs. To us, beauty goes beyond the surface. It's about feeling truly confident inside and out.",
  phone: "+44 (0) 1582 341553",
  email: "contact.auraaesthetix@gmail.com",
  address: "93 Hart Lane, Luton, LU2 0JG",
  website: "www.auraaesthetics.com",
  social: {
    instagram: "@aura_aesthetics.a",
    tiktok: "@aura_aesthetics.a",
    facebook: "@aura_aesthetics.a"
  },
  hours: {
    weekday: "Monday - Friday: 10:00 AM - 5:00 PM",
    saturday: "Saturday: 10:00 AM - 4:00 PM",
    sunday: "Sunday: Closed"
  },
  specialOffer: "Introductory Price: Get 10% Off on Select Treatments"
};

export const services = [
  // IV Vitamin Drips
  {
    id: 1,
    category: "IV Infusions",
    title: "IV Glutathione Drip",
    price: "£45",
    description: "Powerful antioxidant treatment for skin brightening and detoxification.",
    duration: "45 minutes"
  },
  {
    id: 2,
    category: "IV Infusions",
    title: "IV High Dose Vitamin C Drip",
    price: "£55",
    description: "Immune-boosting therapy with high-potency vitamin C.",
    duration: "45 minutes"
  },
  {
    id: 3,
    category: "IV Infusions",
    title: "Skin Brightening IV (Vitamin C + Glutathione)",
    price: "£80",
    description: "Achieve luminous, radiant skin with vitamin C and glutathione combination.",
    duration: "60 minutes"
  },
  {
    id: 4,
    category: "IV Infusions",
    title: "IV Fitness / Sport Performance Drip",
    price: "£75",
    description: "Optimize athletic performance and recovery with targeted nutrients.",
    duration: "60 minutes"
  },
  {
    id: 5,
    category: "IV Infusions",
    title: "IV Slimming Drip",
    price: "£75",
    description: "Targeted nutrients to support metabolism and weight management.",
    duration: "60 minutes"
  },
  {
    id: 6,
    category: "IV Infusions",
    title: "IV Collagen Drip",
    price: "£85",
    description: "Support skin elasticity and natural glow with collagen infusion.",
    duration: "60 minutes"
  },
  {
    id: 7,
    category: "IV Infusions",
    title: "IV Snow White Brightening Drip",
    price: "£90",
    description: "Advanced skin brightening therapy for a radiant, even complexion.",
    duration: "60 minutes"
  },
  {
    id: 8,
    category: "IV Infusions",
    title: "IV Energy Booster Drip",
    price: "£90",
    description: "Revitalize your energy levels with B-complex vitamins and minerals.",
    duration: "60 minutes"
  },
  {
    id: 9,
    category: "IV Infusions",
    title: "IV Detoxification Drip",
    price: "£90",
    description: "Comprehensive detox therapy to cleanse and rejuvenate your system.",
    duration: "60 minutes"
  },
  {
    id: 10,
    category: "IV Infusions",
    title: "IV Myers' Cocktail",
    price: "£105",
    description: "Premium blend of vitamins and minerals for overall wellness and vitality.",
    duration: "60 minutes"
  },
  {
    id: 11,
    category: "IV Infusions",
    title: "IV Anti-Ageing Amino Acid Drip",
    price: "£110",
    description: "Advanced amino acid formula for age-defying rejuvenation.",
    duration: "60 minutes"
  },

  // IM Vitamin Injections
  {
    id: 12,
    category: "IM Injections",
    title: "Vitamin B Complex",
    price: "£25",
    description: "Complete B-vitamin support for energy and wellness.",
    duration: "15 minutes"
  },
  {
    id: 13,
    category: "IM Injections",
    title: "Vitamin B12",
    price: "£25",
    description: "Increase energy and mental clarity with B12 injection.",
    duration: "15 minutes"
  },
  {
    id: 14,
    category: "IM Injections",
    title: "Vitamin C",
    price: "£30",
    description: "Immune-boosting vitamin C injection for overall health.",
    duration: "15 minutes"
  },
  {
    id: 15,
    category: "IM Injections",
    title: "Vitamin D",
    price: "£30",
    description: "Boost bone health and immunity with vitamin D injection.",
    duration: "15 minutes"
  },
  {
    id: 16,
    category: "IM Injections",
    title: "Biotin",
    price: "£30",
    description: "Support healthy hair, skin, and nails with biotin injection.",
    duration: "15 minutes"
  },
  {
    id: 17,
    category: "IM Injections",
    title: "Glutathione Shot",
    price: "£35",
    description: "Quick antioxidant boost for skin and overall health.",
    duration: "15 minutes"
  },

  // Botox & Anti-Wrinkle
  {
    id: 18,
    category: "Botox & Anti-Wrinkle",
    title: "Botox - 1 Area",
    price: "£80",
    description: "Transform your look with a youthful glow, reducing wrinkles in one area.",
    duration: "45 minutes"
  },
  {
    id: 19,
    category: "Botox & Anti-Wrinkle",
    title: "Botox - 2 Areas",
    price: "£140",
    description: "Enhanced wrinkle reduction across two treatment areas.",
    duration: "45 minutes"
  },
  {
    id: 20,
    category: "Botox & Anti-Wrinkle",
    title: "Botox - 3 Areas",
    price: "£180",
    description: "Comprehensive anti-aging treatment for multiple facial areas.",
    duration: "45 minutes"
  },
  {
    id: 21,
    category: "Botox & Anti-Wrinkle",
    title: "Jaw Clenching Treatment",
    price: "£150",
    description: "Reduce jaw tension and achieve facial slimming with targeted Botox.",
    duration: "45 minutes"
  },
  {
    id: 22,
    category: "Botox & Anti-Wrinkle",
    title: "Hyperhidrosis Treatment",
    price: "£160",
    description: "Effective solution for excessive sweating using Botox injections.",
    duration: "45 minutes"
  },

  // Skin Boosters & Advanced Injectables
  {
    id: 23,
    category: "Skin Boosters",
    title: "Lumi Eyes",
    price: "£100",
    description: "Advanced eye rejuvenation treatment for brighter, refreshed eyes.",
    duration: "30 minutes"
  },
  {
    id: 24,
    category: "Skin Boosters",
    title: "Skin Boosters",
    price: "£130",
    description: "Deep hydration and skin quality improvement with injectable boosters.",
    duration: "45 minutes"
  },
  {
    id: 25,
    category: "Skin Boosters",
    title: "Polynucleotides",
    price: "£150",
    description: "Advanced skin regeneration treatment for improved texture and elasticity.",
    duration: "45 minutes"
  },
  {
    id: 26,
    category: "Skin Boosters",
    title: "Polynucleotide Course (3 sessions)",
    price: "£400",
    description: "Complete treatment course for optimal skin regeneration results.",
    duration: "3 sessions"
  },
  {
    id: 27,
    category: "Skin Boosters",
    title: "Profhilo",
    price: "£200",
    description: "Revolutionary bio-remodelling treatment for skin laxity and hydration.",
    duration: "30 minutes"
  },
  {
    id: 28,
    category: "Skin Boosters",
    title: "Profhilo Course (2 sessions)",
    price: "£380",
    description: "Complete Profhilo treatment protocol for maximum anti-aging benefits.",
    duration: "2 sessions"
  },


  // Facial Treatments
  {
    id: 33,
    category: "Facial Treatments",
    title: "High Frequency Facial",
    price: "£50",
    description: "Treats acne, boosts circulation, stimulates collagen, and reduces puffiness.",
    duration: "60 minutes",
    benefits: [
      "Helps treat acne by killing bacteria",
      "Boosts blood circulation for a natural glow",
      "Stimulates collagen & elastin production",
      "Deep cleansing effect and minimizes pores",
      "Reduces puffiness & dark circles under eyes"
    ]
  },
  {
    id: 34,
    category: "Facial Treatments",
    title: "Galvanic Treatment",
    price: "£55",
    description: "Deep cleansing and enhanced product absorption for improved skin texture.",
    duration: "60 minutes",
    benefits: [
      "Deep cleansing removes oil and impurities",
      "Enhances product absorption deep into skin",
      "Improves skin texture & glow",
      "Stimulates circulation",
      "Helps with anti-aging and balances skin"
    ]
  },
  {
    id: 35,
    category: "Facial Treatments",
    title: "Microdermabrasion",
    price: "£60",
    description: "Gentle exfoliation for smoother, brighter skin with improved texture.",
    duration: "60 minutes",
    benefits: [
      "Smoother, softer skin texture",
      "Brighter, more radiant complexion",
      "Unclogs pores & reduces blackheads",
      "Boosts collagen production",
      "Improves mild acne scars & pigmentation"
    ]
  },
  {
    id: 36,
    category: "Facial Treatments",
    title: "Dermaplaning",
    price: "£65",
    description: "Removes dead skin and peach fuzz for instant smoothness and glow.",
    duration: "60 minutes",
    benefits: [
      "Instant smoothness and silky skin",
      "Brighter, glowing complexion",
      "Better product absorption",
      "Flawless makeup application",
      "Removes peach fuzz (vellus hair)"
    ]
  },
  {
    id: 37,
    category: "Facial Treatments",
    title: "HydroFacial",
    price: "£80",
    description: "Deep hydration, cleansing, and extraction for instant radiance.",
    duration: "60 minutes",
    benefits: [
      "Deep hydration with moisture-rich serums",
      "Deep cleansing & gentle exfoliation",
      "Painless extraction of blackheads",
      "Instant glow & radiance",
      "Improves skin texture & tone"
    ]
  },
  {
    id: 38,
    category: "Facial Treatments",
    title: "LED Treatment",
    price: "£45",
    description: "Light therapy targeting acne, aging, pigmentation, and redness.",
    duration: "60 minutes",
    benefits: [
      "Red light: anti-aging, boosts collagen",
      "Blue light: kills acne-causing bacteria",
      "Yellow light: soothes redness & sensitivity",
      "Green light: helps with pigmentation",
      "Supports healing & repair"
    ]
  },
  {
    id: 39,
    category: "Facial Treatments",
    title: "Chemical Peeling",
    price: "£70",
    description: "Deep exfoliation to improve texture, tone, and reduce fine lines.",
    duration: "60 minutes",
    benefits: [
      "Improves skin texture and smoothness",
      "Brightens & evens skin tone",
      "Helps with acne & breakouts",
      "Reduces fine lines & wrinkles",
      "Enhances skincare absorption"
    ]
  },
  {
    id: 40,
    category: "Facial Treatments",
    title: "Micro-Needling",
    price: "£120",
    description: "Stimulates collagen production to reduce scars and improve texture.",
    duration: "60 minutes",
    benefits: [
      "Boosts collagen & elastin production",
      "Reduces acne scars & other scarring",
      "Improves skin texture & tone",
      "Enhances product absorption",
      "Minimizes pore appearance"
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Wadzanai Gondo",
    treatment: "Facial Treatment",
    text: "Just had the most amazing facial! My skin feels so refreshed, smooth, and absolutely glowing! Huge shoutout to Patience the therapist for such a relaxing and professional experience. Every step felt so calming, and I left feeling confident and pampered. Amazing environment, highly recommend definitely coming back again!",
    rating: 5
  },
  {
    id: 2,
    name: "Nicki Scrivener",
    treatment: "Botox Treatment",
    text: "Great service, I had Botox and I felt so comfortable and very informed at all times. Patience is fantastic.",
    rating: 5
  },
  {
    id: 3,
    name: "Char",
    treatment: "Botox Treatment",
    text: "Excellent service and results. Patience is very professional with both pre care and after care. Very knowledgeable. Would highly recommend. I have booked in to try a facial which was highly recommended by a friend.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is IV infusion therapy?",
    answer: "IV infusion therapy delivers vitamins, minerals, and other nutrients directly into your bloodstream for maximum absorption and immediate benefits. It's a safe and effective way to boost wellness, energy, and beauty from within."
  },
  {
    id: 2,
    question: "How long does a typical treatment take?",
    answer: "Most IV infusions take 45-60 minutes, while IM injections are quick 15-minute procedures. Botox and specialized treatments range from 45-90 minutes depending on the area being treated."
  },
  {
    id: 3,
    question: "Is there any downtime after treatment?",
    answer: "Most treatments require minimal to no downtime. You can resume normal activities immediately after IV therapy or IM injections. Botox may have slight redness that subsides within hours."
  },
  {
    id: 4,
    question: "How often should I get treatments?",
    answer: "Treatment frequency depends on your individual goals. IV therapy can be done weekly or monthly, while Botox typically lasts 3-4 months. We'll create a personalized treatment plan during your consultation."
  },
  {
    id: 5,
    question: "Are the treatments safe?",
    answer: "Yes, all treatments are performed by experienced medical professionals with over 20 years of expertise. We use only premium, medical-grade products and follow strict safety protocols."
  },
  {
    id: 6,
    question: "Do I need a consultation before treatment?",
    answer: "We recommend a consultation for first-time clients to discuss your goals, medical history, and create a customized treatment plan. This ensures the best possible results tailored to your needs."
  }
];

export const features = [
  {
    id: 1,
    title: "20+ Years Medical Expertise",
    description: "Trusted medical background with extensive experience in aesthetic treatments and patient care."
  },
  {
    id: 2,
    title: "Premium Medical-Grade Products",
    description: "We use only the highest quality ingredients and medical-grade formulations for optimal results."
  },
  {
    id: 3,
    title: "Personalized Treatment Plans",
    description: "Every client receives customized treatments tailored to their unique needs and aesthetic goals."
  },
  {
    id: 4,
    title: "Comprehensive Aftercare",
    description: "Our commitment extends beyond treatment with thorough aftercare guidance and ongoing support."
  }
];
